/**
 * The real canvases behind the starters, for the ones that have one: the
 * walkthrough's canvas and each template's copy. Read on the canvas detail
 * key the canvas page and the create path already share, so a canvas the
 * cache holds costs nothing and one that is not there costs one fetch. A
 * canvas that is archived or gone counts as none.
 */

import { orgAPI } from "@/api/api";
import type { Canvas } from "@cohesive/api-client";
import { useQueries } from "@tanstack/react-query";

export function useStarterCanvases(
  ids: readonly string[],
): Record<string, Canvas> {
  const results = useQueries({
    queries: ids.map((id) => ({
      queryKey: ["canvas", id],
      queryFn: () => orgAPI.canvas.getById(id),
      staleTime: 30_000,
    })),
  });
  const canvases: Record<string, Canvas> = {};
  results.forEach((result, index) => {
    const canvas = result.data;
    if (canvas && !canvas.archived_at) canvases[ids[index]!] = canvas;
  });
  return canvases;
}
